function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "#148CFC",
  fillRule: "evenodd",
  d: "M7 13.222A6.222 6.222 0 1113.222 7 6.222 6.222 0 017 13.222zM7 1.815A5.185 5.185 0 001.841 6.48h6.5L6.374 4.518a.519.519 0 01.734-.733l2.858 2.853a.518.518 0 010 .733l-2.858 2.853a.519.519 0 11-.734-.733L8.35 7.519H1.84A5.185 5.185 0 107 1.815z"
});

var SvgManageTeamGo = function SvgManageTeamGo(props) {
  return React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14"
  }, props), _ref);
};

export default SvgManageTeamGo;